import { computed, ref, toValue, watchEffect } from 'vue';
export var useTabs = function (defaultTab, tabs) {
    var activeTab = ref(defaultTab);
    var localTabs = computed(function () { return toValue(tabs); });
    watchEffect(function () {
        activeTab.value = toValue(defaultTab);
    });
    return {
        activeTab: activeTab,
        tabs: localTabs,
    };
};
